import React from 'react';

import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const ProfessionalInfoSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  isCollapsed, 
  onToggleCollapse,
  qualifications,
  professions,
  skillSets
}) => {
  return (
    <div className="bg-card border border-border rounded-lg shadow-spiritual-sm mb-6">
      <div 
        className="flex items-center justify-between p-4 cursor-pointer hover:bg-muted/50 transition-colors"
        onClick={onToggleCollapse}
      >
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-success/10 rounded-lg flex items-center justify-center">
            <Icon name="Briefcase" size={20} className="text-success" />
          </div>
          <div>
            <h3 className="font-heading font-semibold text-foreground">
              Professional Information
            </h3>
            <p className="text-sm text-muted-foreground">
              Educational qualifications and professional skills
            </p>
          </div>
        </div>
        <Icon 
          name={isCollapsed ? "ChevronDown" : "ChevronUp"} 
          size={20} 
          className="text-muted-foreground" 
        />
      </div>

      {!isCollapsed && (
        <div className="p-6 pt-6 border-t border-border">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Select
              label="Qualification"
              placeholder="Select qualification"
              options={qualifications}
              value={formData.qualification}
              onChange={(value) => handleInputChange('qualification', value)}
              error={errors.qualification}
              searchable
            />

            <Select
              label="Profession"
              placeholder="Select profession"
              options={professions}
              value={formData.profession}
              onChange={(value) => handleInputChange('profession', value)}
              error={errors.profession}
              searchable
            />

            <div className="md:col-span-2">
              <Select
                label="Skill Set"
                placeholder="Select skills"
                options={skillSets}
                value={formData.skillSet}
                onChange={(value) => handleInputChange('skillSet', value)}
                error={errors.skillSet}
                multiple
                searchable
                clearable
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfessionalInfoSection;